// extracted by mini-css-extract-plugin
export default {"button":"SentryFeedbackButton_button__u6+Vs"};